const GROUPING_DEBUG_STORAGE_KEY = 'debug.grouping.flow';

const isGroupingDebugEnabled = () => {
  if (typeof window === 'undefined') return false;

  try {
    if (window.__DEBUG_GROUPING_FLOW__ === true) return true;
    return window.localStorage && window.localStorage.getItem(GROUPING_DEBUG_STORAGE_KEY) === '1';
  } catch (error) {
    return false;
  }
};

export const logGroupingDebug = (event, payload = {}) => {
  if (!isGroupingDebugEnabled()) return;

  // eslint-disable-next-line no-console
  console.warn('[GroupingDebug]', {
    event,
    at: new Date().toISOString(),
    ...payload
  });
};

export const GROUPING_DEBUG_FLAG = GROUPING_DEBUG_STORAGE_KEY;
